<ng-container>
    <div class="dropdown-wrapper">
        <ham-button
            #dueDateButtonWrapper
            class="date-button"
            size="lg"
            [variant]="hasSelection() ? 'transparent' : 'white'"
            [outline]="true"
            rightIcon="assets/hamIcons/chevron-down.svg"
            (click)="
                showDateRangePickerOnly ? openDateRangePicker(dueDateButtonWrapper) : openFlyout(dueDateButtonWrapper)
            "
        >
            {{ translationKeyFilterName | i18next }}
        </ham-button>
    </div>

    <span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
        <div class="date-picker-flyout-content">
            <div
                *ngFor="let option of filterOptions"
                class="dates-option"
                (click)="multiSelect ? onFilterToggle(option.value) : onFilterChange(option.value)"
                [class.selected]="isOptionSelected(option.value)"
            >
                <label
                    class="option-label"
                    [class.checkbox-mode]="multiSelect"
                    (click)="multiSelect && $event.stopPropagation()"
                >
                    <input
                        *ngIf="multiSelect"
                        class="option-checkbox"
                        type="checkbox"
                        [checked]="isOptionSelected(option.value)"
                        (click)="$event.stopPropagation()"
                        (change)="onFilterToggle(option.value)"
                    />
                    <span>{{ option.label }}</span>
                </label>
            </div>
            <div class="filter-actions">
                <ham-button
                    *ngIf="multiSelect"
                    class="apply-button"
                    variant="teal"
                    size="sm"
                    (click)="applyMultiSelection()"
                >
                    {{ 'aumico_pm_tasks_filter_apply' | i18next }}
                </ham-button>
                <ham-button class="clear-button" variant="white" size="sm" (click)="clearCustomDates()">{{
                    'aumico_pm_tasks_filter_clear' | i18next
                }}</ham-button>
            </div>
        </div>
    </span>
</ng-container>

<span class="menu-flyout" hamFlyout *ngIf="showCustomRange" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-custom-date-picker-content" [ngClass]="{ 'pick-day-mode': pickDay }">
        <div class="custom-datepicker-wrapper">
            <div class="range-picker-wrapper">
                <div class="mat-calendar-container">
                    <!-- Start Calendar -->
                    <mat-calendar
                        [selected]="customStartDate"
                        [startAt]="customStartDate || today"
                        (selectedChange)="setStartDate($event)"
                    ></mat-calendar>
                    <div class="datepicker-actions">
                        <ham-button variant="teal" size="sm" (click)="selectStartDateToday()">{{
                            'aumico_pm_tasks_select_date_today' | i18next
                        }}</ham-button>
                    </div>
                </div>

                <div class="mat-calendar-container" *ngIf="!pickDay">
                    <!-- End Calendar -->
                    <mat-calendar
                        [selected]="customEndDate"
                        [startAt]="customEndDate || customStartDate || today"
                        (selectedChange)="setEndDate($event)"
                    ></mat-calendar>
                    <div class="datepicker-actions">
                        <ham-button variant="white" size="sm" (click)="clearCustomDates()">{{
                            'aumico_pm_tasks_filter_clear' | i18next
                        }}</ham-button>
                    </div>
                </div>
            </div>
            <div class="custom-actions" *ngIf="multiSelect">
                <ham-button variant="teal" size="sm" (click)="applyMultiSelection()">{{
                    'aumico_pm_tasks_filter_apply' | i18next
                }}</ham-button>
            </div>
        </div>
    </div>
</span>
